import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { Grid_TherapistModel } from "./Grid_TherapistModel";

export class Grid_TherapistFindResultModel extends BaseFindResult {

    public getDataItem(i: number): Grid_TherapistModel {
        let o: Grid_TherapistModel = Object.assign(new Grid_TherapistModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): Grid_TherapistModel[] {

        let d: Grid_TherapistModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: Grid_TherapistModel = Object.assign(new Grid_TherapistModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
